import * as React from "react";
const WindSpeed = ({ color, width, height }) => (
    <svg
        width={width} height={height}
        viewBox="0 0 65 55"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.5 21.8558H23.4355"
            stroke={color}
            strokeWidth={5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.5 42.8229H15.371"
            stroke={color}
            strokeWidth={5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.5 33.145H49.242"
            stroke={color}
            strokeWidth={5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.3774 9.30547C13.911 7.58862 14.9123 6.05435 16.269 4.87469C17.6257 3.69503 19.2842 2.91662 21.0585 2.62674C22.8328 2.33687 24.6528 2.54699 26.3144 3.23354C27.976 3.9201 29.4135 5.05594 30.4657 6.51372C31.5179 7.97149 32.1433 9.69356 32.2716 11.4868C32.3999 13.2801 32.0262 15.0736 31.1922 16.6664C30.3583 18.2591 29.0972 19.5881 27.5503 20.5042C26.0034 21.4204 24.2319 21.8875 22.4343 21.8532"
            stroke={color}
            strokeWidth={5}
            strokeLinecap="round"
        />
        <path
            d="M39.1743 20.5986C39.7079 18.8818 40.7091 17.3475 42.0658 16.1678C43.4226 14.9882 45.0811 14.2098 46.8554 13.9199C48.6297 13.63 50.4497 13.8401 52.1113 14.5267C53.7729 15.2132 55.2104 16.3491 56.2626 17.8069C57.3148 19.2646 57.9401 20.9867 58.0685 22.78C58.1968 24.5732 57.823 26.3668 56.9891 27.9595C56.1552 29.5523 54.8941 30.8812 53.3472 31.7974C51.8003 32.7135 50.0287 33.1807 48.2312 33.1464"
            stroke={color}
            strokeWidth={5}
            strokeLinecap="round"
        />
        <path
            d="M38.738 33.145C40.5358 33.145 42.2981 33.6458 43.8273 34.5913C45.3565 35.5368 46.592 36.8896 47.3954 38.4979C48.1988 40.1063 48.5383 41.9066 48.3758 43.6971C48.2133 45.4876 47.5553 47.1974 46.4755 48.6349C45.3956 50.0723 43.9367 51.1806 42.2624 51.8353C40.588 52.4901 38.7643 52.6654 36.9958 52.3418C35.2273 52.0181 33.584 51.2082 32.25 50.0029C30.916 48.7976 29.9442 47.2445 29.4435 45.5178"
            stroke={color}
            strokeWidth={5}
            strokeLinecap="round"
        />
    </svg>
);
export default WindSpeed;
